export const RAPTOR_TRACKING_OBJECT_NAMES = {
    event: 'event',
    eventCategory: 'eventCategory',
    eventAction: 'eventAction',
    eventLabel: 'eventLabel',
    eventValue: 'eventValue'
  }